<template>
  <v-container class="pt-0">
    <v-form ref="form">
      <v-row justify="center">
        <v-col md="8" xs="12">
          <v-card
            v-if="demo"
            :flat="!$vuetify.breakpoint.smAndUp"
            class="mb-3"
            color="primary"
            tile
          >
            <v-card-title style="color: white"> This is a demo. </v-card-title>
            <v-card-text style="color: white">
              Demo links cannot be used for real jobs.
            </v-card-text>
          </v-card>

          <v-card
            v-if="artLink"
            :flat="!$vuetify.breakpoint.smAndUp"
            class="mb-3"
            color="accent"
            tile
          >
            <v-card-title style="color: white">
              This is an art department timecard link.
            </v-card-title>
            <v-card-text style="color: white">
              Your submission will be sent to the art coordinator.
            </v-card-text>
          </v-card>

          <job-submission-info :job="submission" :art-link="artLink" />

          <v-card :flat="!$vuetify.breakpoint.smAndUp" class="my-3">
            <v-card-title :class="!$vuetify.breakpoint.smAndUp ? 'pa-0' : ''">
              Your Information
            </v-card-title>
            <v-card-text :class="!$vuetify.breakpoint.smAndUp ? 'pa-0' : ''">
              <v-row>
                <v-col md="6" cols="12" class="py-0">
                  <v-text-field
                    v-model="submission.employee.firstName"
                    label="First Name*"
                    :rules="[rules.required]"
                    type="text"
                    data-cy="dot-text-first-name"
                  />
                </v-col>
                <v-col md="6" cols="12" class="py-0">
                  <v-text-field
                    v-model="submission.employee.lastName"
                    label="Last Name*"
                    :rules="[rules.required]"
                    type="text"
                    data-cy="dot-text-last-name"
                  />
                </v-col>
                <v-col cols="6" class="py-0">
                    <DatePickerDialog
                      year-first
                      v-model="submission.employee.birthday"
                      label="Date of Birth"
                      :rules="[rules.required]"
                      data-cy="dot-date-picker-dob"
                    />
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-text-field
                    v-model="submission.employee.licenseNumber"
                    label="Driver's License Number*"
                    :rules="[rules.required]"
                    data-cy="dot-text-license-number"
                  />
                </v-col>
                <v-col cols="6" class="py-0">
                    <DatePickerDialog
                      year-first
                      v-model="submission.employee.expirationDate"
                      label="License Expiration Date"
                      :rules="[rules.required]"
                      data-cy="caps-date-picker-expiration-date"
                    />
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-select
                    v-model="submission.employee.address.state"
                    :items="stateList"
                    label="State*"
                    :rules="[rules.required]"
                    persistent-hint
                  >
                  </v-select>
                </v-col>
                <v-col cols="6" md="6" class="py-0">
                  <v-text-field
                    ref="vehicleClass"
                    v-model="submission.employee.vehicleClass"
                    label="Class of License*"
                    :rules="[rules.required]"
                    data-cy="caps-text-vehicle-class"
                  />
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-text-field
                    ref="registryNumber"
                    v-model="submission.employee.registryNumber"
                    label="National Registry Number on Your Medical Card*"
                    hint="Registry Number is 10 digits"
                    :rules="[rules.numeric]"
                    data-cy="caps-text-registry-number"
                  />
                </v-col>
                <v-col
                  cols="6"
                  md="6"
                  class="py-0"
                >
                  <v-text-field
                    v-model="submission.employee.socialSecurityNumber"
                    label="Last 4 Digits of Security Number*"
                    :rules="[rules.required, rules.socialMax, rules.socialMin]"
                    data-cy="dot-text-ssn"
                  />
                </v-col>
                <v-col cols="6" md="6" class="py-0">
                  <p>Is This a Commercial Driver's license: {{ isCommercialLicense }}</p>
                  <v-radio-group
                    v-model="submission.employee.isCommercialLicense"
                    row
                    :rules="[rules.required]"
                  >
                    <v-radio
                      label="Yes"
                      value="yes"
                    ></v-radio>
                    <v-radio
                      label="No"
                      value="no"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card :flat="!$vuetify.breakpoint.smAndUp">
            <v-card-title :class="!$vuetify.breakpoint.smAndUp ? 'pa-0' : ''">
              Submit
            </v-card-title>
            <v-card-text :class="!$vuetify.breakpoint.smAndUp ? 'pa-0' : ''">
              <v-row wrap no-gutters justify="center">
                <v-col
                  cols="12"
                  class="pb-0 pt-4 mt-0"
                  style="text-align: center; font-size: 12px; line-height: 12px"
                >
                  <i
                    >The parties agree that this agreement may be electronically
                    signed. The parties agree that the electronic signatures
                    appearing on this agreement are the same as handwritten
                    signatures for the purposes of validity, enforceability and
                    admissibility.</i
                  >
                  <v-checkbox
                    v-model="consentToElectronicSignature"
                    :rules="[rules.required]"
                    label="I agree with the above and consent to doing business online."
                    data-cy="caps-checkbox-digital-business"
                  />
                  <v-checkbox
                    v-if="
                      job.isNdaIncluded && submission.includeStartingPaperwork
                    "
                    v-model="consentToNDA"
                    :rules="[rules.required]"
                    label="Agree to NDA"
                  />
                </v-col>
                <v-col cols="auto" class="pa-0">
                  Employee Signature
                  <SignaturePad ref="signaturePad" />
                </v-col>
                <v-col cols="12" class="pt-4" style="text-align: center">
                  An email will be sent to the address you listed
                  <b>
                    {{
                      submission.employee.email
                        ? `(${submission.employee.email})`
                        : ""
                    }}
                  </b>
                  containing a copy of these generated forms.
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions>
              <v-row justify="center">
                <v-col cols="auto">
                  <DotJobSubmissionPreviewDialog
                    v-model="showPreviewDialog"
                    :pdf-src="pdfSrc"
                    :loading="sendingToProductionManager"
                    :processing-preview="processingPreview"
                    :num-pages="numPages"
                    @show-preview="showPreview()"
                    @submit="submit()"
                  />
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>change

<style scoped lang="scss">
@import "@/scss/main";

.date-row {
  border-bottom: 1px solid $gray-light;
}

.wider-expansion {
  margin: -24px -24px;
}

.accordion-checkbox {
  padding-top: 22px;
  width: 205px;
}

.dropdown-cover {
  margin-right: -36px;
  z-index: 2;
  background-color: white;
}

.rate-change {
  margin: 1px;
}
</style>

<script>
import pdf from "vue-pdf";
import { DateTime } from "luxon";
import { mask } from "vue-the-mask";
import masks from "../utils/masks";
import { getUnions } from "../services/unions";
import SignaturePad from "../components/SignaturePad.vue";
import { generateForm, getJobFromHash } from "../services/jobs";
import TimePickerDialog from "../components/TimePickerDialog.vue";
import DatePickerDialog from "../components/DatePickerDialog.vue";
import SundayDatePickerDialog from "../components/SundayDatePickerDialog.vue";
import JobSubmissionW4WithholdingsTooltip from "../assets/JobSubmissionW4WithholdingsTooltip.png";
import InvoiceJobSubmissionKitMileageRental from "../components/InvoiceJobSubmissionKitMileageRental.vue";
import JobSubmissionInfo from "../components/JobSubmissionInfo.vue";
import JobSubmissionFreelancerNotes from "../components/JobSubmissionFreelancerNotes.vue";
import JobSubmissionInvoiceW9 from "../components/JobSubmissionInvoiceW9.vue";
import DotJobSubmissionPreviewDialog from "../components/DotJobSubmissionPreviewDialog.vue";
import FileMultipleUpload from "../components/FileMultipleUpload.vue";
import { CALIFORNIA_MARKET_KEY } from "../services/markets";

export default {
  filters: {
    dayOfWeekFilter(date, index) {
      return date
        ? DateTime.fromFormat(date, "yyyy-MM-dd")
            .plus({ days: index })
            .toFormat("MM/dd/yy")
        : "--/--";
    },
  },
  components: {
    SignaturePad,
    TimePickerDialog,
    SundayDatePickerDialog,
    DatePickerDialog,
    JobSubmissionInvoiceW9,
    InvoiceJobSubmissionKitMileageRental,
    JobSubmissionFreelancerNotes,
    JobSubmissionInfo,
    DotJobSubmissionPreviewDialog,
    FileMultipleUpload,
  },
  directives: {
    mask,
  },
  props: {
    artLink: {
      type: Boolean,
    },
  },
  data() {
    return {
      unsavedDataCreated: false,
      CALIFORNIA_MARKET_KEY,
      settingUpPage: true,
      processingPreview: false,
      sendingToProductionManager: false,
      demo: false,
      consentToElectronicSignature: false,
      consentToNDA: false,
      JobSubmissionW4WithholdingsTooltip,
      w9Upload: null,
      articleOfIncorporationUpload: null,
      pdfSrc: null,
      numPages: null,
      openedPanel: [],
      page: 1,
      showPreviewDialog: false,
      additionalFilesUpload: [""],
      ethnicities: [
        "Choose Not to Disclose",
        "Two or More Races",
        "Hispanic/Latino",
        "White/Caucasian",
        "Black or African American",
        "Native American or Alaska Native",
        "Native Hawaiian or Pacific Islander",
        "Asian",
      ],
      genders: ["Male", "Female", "Other"],
      preferredPaymentMethods: ["ACH", "Check", "Zelle"],
      stateList: [
        'AL','AK','AZ','AR','CA','CO','CT',
        'DE','FL','GA','HI','ID','IL','IN','IA','KS','KY',
        'LA','ME','MD','MA','MI','MN','MS','MO','MT','NE',
        'NV','NH','NJ','NM','NY','NC','ND','OH','OK','OR',
        'PA','RI','SC','SD','TN','TX','UT','VT','VA','WA',
        'WV','WI','WY'
      ],
      rateTypes: [
        {
          text: "For 10 Hours",
          value: "10hour",
        },
        {
          text: "For 12 Hours",
          value: "12hour",
        },
      ],
      dayTypes: [
        {
          text: "Normal",
          value: "normal",
        },
        {
          text: "Travel (Full)",
          value: "travel_full",
        },
        {
          text: "Travel (Half)",
          value: "travel_half",
        },
      ],
      unions: [],
      maritalStatuses: [
        {
          text: "Single or Married filing separately",
          value: "single",
        },
        {
          text: "Married filing jointly (or Qualifying widow(er))",
          value: "married",
        },
        {
          text: "Head of Household",
          value: "headOfHouse",
        },
      ],
      citizenshipStatuses: [
        {
          text: "Citizen",
          value: "citizen",
        },
        {
          text: "Non-Citizen National",
          value: "noncitizenNational",
        },
        {
          text: "Lawful Permanent Resident",
          value: "lawfulPermanentResident",
        },
        {
          text: "Alien Authorized to Work",
          value: "alienAuthorizedToWork",
        },
      ],
      i9DocumentTypes: [
        {
          text: "Passport",
          value: "passport",
        },
        {
          text: "Drivers License",
          value: "driversLicense",
        },
        {
          text: "Other",
          value: "other",
        },
      ],
      workAuthorizationTypes: [
        {
          text: "Alien Registration/USCIS Number",
          value: "alienRegistrationUSCISNumber",
        },
        {
          text: "Form I-94 Admission Number",
          value: "formI94AdmissionNumber",
        },
        {
          text: "Foreign Passport",
          value: "foreignPassport",
        },
      ],
      openPDF: false,
      date: null,
      timeZone: null,
      masks,
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        registryMax: (value) => value.length <= 10 || "Must be 10 numbers",
        registryMin: (value) => value.length > 9 || "Must be 10 numbers",
        socialMax: (value) => value.length <= 4 || "Must be 4 numbers",
        socialMin: (value) => value.length > 3 || "Must be 4 numbers",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
        numeric: (value) => {
          if (!value) return true;
          if (/[a-zA-Z ]/.test(value)) return "Not a valid number.";
          return !Number.isNaN(parseFloat(value)) || "Not a valid number.";
        },
      },
      jobId: null,
      job: null,
      submission: {
        date: null,
        isPreview: true,
        sendEmployeeCopy: true,
        reimbursement: "0",
        name: "",
        number: "",
        company: {
          employer: {
            firstName: "Nicole",
            lastName: "Holloway",
          },
          name: "",
          address: {
            streetName: "823 Seward Street",
            city: "Los Angeles",
            state: "CA",
            zipCode: "90038",
          },
        },
        employee: {
          firstName: "",
          middleName: "",
          lastName: "",
          telephone: "1234567890",
          rateType: "Hour",
          socialSecurityNumber: "",
          licenseNumber: "",
          address: {
            streetName: "",
            city: "",
            state: "",
            zipCode: "",
          },
          isUnion: true,
          email: "",
          union: "",
          birthday: "",
          occupation: "",
          ethnicity: "",
          loanOut: "",
          federalId: "",
          passport: {},
          isManager: false,
          primaryLanguage: "",
          isEnglishPrimary: true,
          experationDate: "",
          registryNumber: "",
          isCommercialLicense: "",
          class: "",
        },
        includeStartingPaperwork: true,
        exemptFromWithholdings: false,
        times: [
          {
            dayOfWeek: "Sunday",
          },
          {
            dayOfWeek: "Monday",
          },
          {
            dayOfWeek: "Tuesday",
          },
          {
            dayOfWeek: "Wednesday",
          },
          {
            dayOfWeek: "Thursday",
          },
          {
            dayOfWeek: "Friday",
          },
          {
            dayOfWeek: "Saturday",
          },
        ],
        uploads: [],
      },
    };
  },
  computed: {
    lawfulPermanentResident() {
      return (
        this.submission.employee.citizenshipStatus === "lawfulPermanentResident"
      );
    },
    isAlienAuthorizedToWork() {
      return (
        this.submission.employee.citizenshipStatus === "alienAuthorizedToWork"
      );
    },
    workAuthorization() {
      return this.submission.employee.workAuthorization;
    },
    workAuthorizationExpires() {
      return (
        this.isAlienAuthorizedToWork &&
        this.submission.employee.workAuthorization.expires
      );
    },
    alienRegistrationUSCISNumberAuthorization() {
      return (
        (this.isAlienAuthorizedToWork &&
          this.workAuthorization.type === "alienRegistrationUSCISNumber") ||
        this.lawfulPermanentResident
      );
    },
    formI94AdmissionNumberAuthorization() {
      return (
        this.isAlienAuthorizedToWork &&
        this.workAuthorization.type === "formI94AdmissionNumber"
      );
    },
    foreignPassportAuthorization() {
      return (
        this.isAlienAuthorizedToWork &&
        this.workAuthorization.type === "foreignPassport"
      );
    },
    occupations() {
      return this.unions.find(
        (union) => union.union === this.submission.employee.union
      )?.occupations;
    },
    isCaliforniaMarket() {
      return this.submission?.market?.key === "california";
    },
    isNewYorkMarket() {
      return this.submission?.market?.key === "new_york";
    },
  },
  watch: {
    date() {
      const date = DateTime.fromFormat(this.date, "yyyy-MM-dd").toLocal();
      this.submission.times.forEach((time, index) => {
        time.date = date.plus({ day: index }).toISO();
        time.start = DateTime.fromISO(
          `${date.plus({ day: index }).toISO().split("T")[0]}T${time.startTime}`
        ).toISO();
        time.end = DateTime.fromISO(
          `${date.plus({ day: index }).toISO().split("T")[0]}T${time.endTime}`
        ).toISO();
        time.meals.forEach((meal) => {
          meal.start = DateTime.fromISO(
            `${date.plus({ day: index }).toISO().split("T")[0]}T${
              meal.startTime
            }`
          ).toISO();
          meal.end = DateTime.fromISO(
            `${date.plus({ day: index }).toISO().split("T")[0]}T${meal.endTime}`
          ).toISO();
        });
      });
    },
    submission: {
      deep: true,
      handler(newVal, oldVal) {
        console.log('getting in here!');
        console.log(this.job.hash);
        // Anytime the user inputs something it saves it to local storage so their submission
        // data won't be lost for that specific job even if they leave. Key is the hash and value is the submission object
        localStorage.setItem(this.job.hash, JSON.stringify(this.submission));
        this.date = this.submission.date;
        if (!this.settingUpPage) {
          this.unsavedDataCreated = true;
        }
      },
    },
    showPreviewDialog(val) {
      if (!val) this.pdfSrc = null;
    },
  },
  async mounted() {
    this.timeZone = DateTime.local().zoneName;
    this.demo = this.$route.query.demo === "true";
    this.bypassSignature = this.$route.query.bypassSignature === "true";
    if (this.$route.query.prefilled === "true") {
      this.submission.employee = {
        firstName: "Sam",
        middleName: "Bruce",
        lastName: "Crane",
        telephone: "1234567890",
        gender: "",
        socialSecurityNumber: "123456789",
        address: {
          streetName: "823 Seward Street",
          city: "Los Angeles",
          state: "CA",
          zipCode: "90038",
        },
        isUnion: true,
        isManager: false,
        email: "samcrane8@gmail.com",
        union: "44",
        occupation: "GUY",
        loanOut: "",
        federalId: "",
        birthday: "",
        citizenshipStatus: "citizen",
        rateType: "Hour",
        RateTypeOther: "",
        rate: 12,
        passport: {},
        driversLicense: {
          number: "",
          issuingAuthority: "",
        },
        workAuthorization: {
          expires: false,
          expirationDate: DateTime.local().toFormat("yyyy-MM-dd"),
        },
      };

      this.submission.w4.numChildren = 1;
      this.submission.w4.numOtherDependents = 1;
    }
    const date = DateTime.fromFormat("2011-12-18", "yyyy-MM-dd").toLocal();
    this.submission.times = this.submission.times.map((time, index) => ({
      ...time,
      workedToday: false,
      date: date.plus({ day: index }).toISO(),
      zipCode: null,
      start: "2011-12-19T15:28:46.493Z",
      startTime: "09:00",
      endTime: "18:00",
      end: "2011-12-19T15:28:46.493Z",
      recordSecondMeal: false,
      mealPenalty: false,
      meals: [
        {
          startTime: "12:00",
          endTime: "13:00",
        },
        {
          startTime: "12:00",
          endTime: "13:00",
        },
      ],
      dayType: "normal",
      chargeKitRental: false,
    }));
    const hash = this.$route.params.hash.replace(/[^a-z0-9]/gi, "");
    try {
      const { data } = await getJobFromHash(hash);
      this.job = data;
      console.log(this.job);
      const { id, name, number, company, notes, market } = data;
      this.submission.market = market;
      this.submission.company = company;
      this.submission.name = name;
      this.submission.number = number;
      this.submission.notes = notes;
      this.jobId = id;
      this.hasEmployeeStartForm = this.job.hasEmployeeStartForm;
      this.submission = JSON.parse(JSON.stringify(this.submission));
    } catch (e) {
      this.$router.push({ name: "404" });
    }
    this.submission.i9.documents.driversLicense.issuingAuthority =
      this.job.market.abbreviation;
    this.unions = getUnions();
    this.$nextTick(() => {
      this.settingUpPage = false;
    });

    // Checks to see if the job submission table is in the local storage dictionary.
    // If it isn't, adds it to the dictionary. If it is, replaces the submission object
    if (!localStorage.getItem(this.job.hash)) {
      localStorage.setItem(this.job.hash, JSON.stringify(this.submission));
    } else {
      this.submission = JSON.parse(localStorage.getItem(this.job.hash));
    }
  },
  beforeRouteLeave(to, from, next) {
    if (from.name !== "caps" || !this.unsavedDataCreated) {
      next();
      return;
    }
    const answer = window.confirm(
      "Your changes will be saved to device and available for the next time you want to continue filling out your paperwork."
    );
    if (answer) {
      next();
    } else {
      next(false);
    }
  },
  methods: {
    validate() {
      if (!this.$refs.form.validate()) {
        this.scrollToFirstFormError();
        return false;
      }
      if (this.$refs.signaturePad.isEmpty() && !this.bypassSignature) {
        this.$emit("snackbar", { text: "You must sign first.", color: "red" });
        return false;
      }
      return true;
    },
    async showPreview() {
      if (!this.validate()) {
        return;
      }
      this.processingPreview = true;
      const { jobId, submission } = await this.prepareSubmission();
      try {
        const { data } = await generateForm({
          jobId,
          submission,
          uploads: [],
          timeZone: this.timeZone,
        });
        console.log('generated form');
        const objectUrl = URL.createObjectURL(
          new Blob([data], { type: "application/pdf" })
        );
        this.pdfSrc = pdf.createLoadingTask(objectUrl);
        this.pdfSrc.promise.then((_pdf) => {
          this.numPages = _pdf.numPages;
          this.showPreviewDialog = true;
          this.processingPreview = false;
          URL.revokeObjectURL(objectUrl);
        });
      } catch (e) {
        if (e.response.status === 502) {
          this.$emit("snackbar", { text: "502 Bad Gateway", color: "red" });
        } else {
          this.$emit("snackbar", {
            text: "Error Submitting Forms",
            color: "red",
          });
        }
        this.processingPreview = false;
      }
    },
    async submit() {
      if (!this.validate()) {
        return;
      }
      this.sendingToProductionManager = true;
      const { jobId, submission } = await this.prepareSubmission();
      submission.isPreview = false;
      this.showPreviewDialog = false;
      try {
        await generateForm({
          jobId,
          submission,
          uploads: [],
          timeZone: this.timeZone,
          artLink: this.artLink,
        });
        this.sendingToProductionManager = false;
        this.unsavedDataCreated = false;

        // Deletes user's data from their local device
        delete localStorage[this.job.hash];

        this.$router.push({
          name: "formComplete",
          params: {
            firstName: submission.employee.firstName,
            lastName: submission.employee.lastName,
            job: this.job,
            freelancerEmail: submission.employee.email,
          },
        });
      } catch (e) {
        if (e.response.status === 502) {
          this.$emit("snackbar", { text: "502 Bad Gateway", color: "red" });
        } else {
          this.$emit("snackbar", {
            text: "Error Submitting Forms",
            color: "red",
          });
        }
        this.sendingToProductionManager = false;
      }
    },
    scrollToFirstFormError() {
      let firstInvalidInput;
      this.$refs.form.inputs.some((input) => {
        if (!input.valid) {
          firstInvalidInput = input;
        }
        return !input.valid;
      });
      if (firstInvalidInput) {
        this.$vuetify.goTo(firstInvalidInput.$el);
      }
    },
    async prepareSubmission() {
      console.log('preparing submission...');
      const submission = JSON.parse(JSON.stringify(this.submission));
      submission.signature = this.$refs.signaturePad.getSignatureImage();
      return {
        jobId: this.jobId,
        submission,
      };
    },
  },
};
</script>
